import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axios from '@src/service/axios';
import { setLoading } from '../../../../@core/components/skelton/store';

export const getTawkTo = createAsyncThunk('tawkToSlice/getTawkTo', async (_, { dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.get('/get-tawkto-configuration', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const createTawkTo = createAsyncThunk('tawkToSlice/createTawkTo', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/tawkto-configuration', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(getTawkTo());
        toast.success(response?.data?.message || 'TawkTo added successfully.');
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateTawkTo = createAsyncThunk('tawkToSlice/createTawkTo', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/tawkto-configuration/' + data.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(getTawkTo());
        toast.success(response?.data?.message || 'TawkTo updated successfully.');
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateTawkToStatus = createAsyncThunk('tawkToSlice/updateTawkToStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/tawkto-configuration/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(getTawkTo());
        toast.success(response?.data?.message || 'TawkTo status updated successfully.');
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const deleteTawkTo = createAsyncThunk('tawkToSlice/deleteTawkTo', async (id, { dispatch }) => {
    try {
        let response = await axios.delete('/tawkto-configuration/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(getTawkTo());
        toast.success(response?.data?.message || 'TawkTo deleted successfully.');
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const tawkToSlice = createSlice({
    name: 'tawkToSlice',
    initialState: {
        data: []
    },
    extraReducers: (builder) => {
        builder.addCase(getTawkTo.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
    }
});

export default tawkToSlice.reducer;
